export class DateSplit{
  day: Date;
  hour: string;
  minute: string;

  constructor(day: Date, hour: string, minute: string) {
    this.day = day;
    this.hour = hour;
    this.minute = minute;
  }

  public getFullDate(): Date {
    let fullDate: Date = this.day;

    fullDate.setHours( Number(this.hour), Number(this.minute), 0, 0);

    return fullDate;
  }

  public clone(): DateSplit{
    return new DateSplit(new Date(this.day), this.hour, this.minute)
  }
}
